import React from 'react';
import { useTranslation } from 'react-i18next';
import Error404 from '../../assets/images/404Error.svg';
import { NavLink } from 'react-router-dom/cjs/react-router-dom';

export default function ErrorSection() {
  const { t } = useTranslation();
  return (
    <>
      <div className="errorSectionContainer">
        <div className="errorSectionContentDiv">
          <h1>{t('Oops.')}</h1>
          <h2>{t("The Page You're Looking For Can't Be Found.")}</h2>
          <div className="errorDivider" />
          <p>
            {t(
              "It looks like you've stumbled upon a missing link. Don't worry, we're here to help you find your way."
            )}
          </p>
          <div className="errorSectionBtnContainer">
            <NavLink className="ErrorSectionNavLinksActive" to="/">
              {t('Home')}
            </NavLink>
            <NavLink className="ErrorSectionNavLinks" to="/about">
              {t('About Us')}
            </NavLink>
            <NavLink className="ErrorSectionNavLinks" to="/ourprojects">
              {t('Projects')}
            </NavLink>
            <NavLink className="ErrorSectionNavLinks" to="/contactus">
              {t('Contact Us')}
            </NavLink>
          </div>
        </div>
        <div className="errorSectionImageDiv">
          <img src={Error404} alt="404error" />
        </div>
      </div>
    </>
  );
}
